import { palette } from './palette';

export function CycleTimeChart({ data, avg }: { data: number[]; avg: number | null }) {
  const w = 360;
  const h = 110;
  const pad = 18;
  const max = Math.max(110, ...data, avg ?? 0) * 1.05;
  const bw = data.length > 0 ? (w - pad * 2) / data.length : 0;
  const yAvg = avg != null ? h - pad - (avg / max) * (h - pad * 2) : null;

  return (
    <svg viewBox={`0 0 ${w} ${h}`} className="h-[110px] w-full">
      {[30, 60, 90].map((v) => {
        const y = h - pad - (v / max) * (h - pad * 2);
        return (
          <g key={v}>
            <line x1={pad} y1={y} x2={w - pad} y2={y} stroke={palette.hair} strokeDasharray="2 4" />
            <text
              x={pad - 4}
              y={y + 3}
              fontSize="8"
              fill={palette.faint}
              textAnchor="end"
              fontFamily="ui-monospace, monospace"
            >
              {v}s
            </text>
          </g>
        );
      })}
      {data.map((v, i) => {
        const bh = (v / max) * (h - pad * 2);
        const x = pad + i * bw + 2;
        const isLast = i === data.length - 1;
        return (
          <rect
            key={i}
            x={x}
            y={h - pad - bh}
            width={Math.max(2, bw - 4)}
            height={bh}
            rx="2"
            fill={isLast ? palette.goodInk : palette.good}
            opacity={isLast ? 1 : 0.55}
          />
        );
      })}
      {yAvg != null && (
        <>
          <line
            x1={pad}
            y1={yAvg}
            x2={w - pad}
            y2={yAvg}
            stroke={palette.dark}
            strokeWidth={1.5}
            strokeDasharray="4 3"
          />
          <text
            x={w - pad}
            y={yAvg - 4}
            fontSize="9"
            fill={palette.dark}
            textAnchor="end"
            fontWeight="700"
          >
            avg {formatAvg(avg)}
          </text>
        </>
      )}
      {data.length === 0 && (
        <text
          x={w / 2}
          y={h / 2}
          fontSize="11"
          fill={palette.faint}
          textAnchor="middle"
          dominantBaseline="middle"
        >
          No completed tasks yet
        </text>
      )}
    </svg>
  );
}

function formatAvg(s: number | null): string {
  if (s == null) return '—';
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  const r = s % 60;
  return r > 0 ? `${m}m ${r}s` : `${m}m`;
}
